import { Component, OnInit, ViewChild } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ModalConfirmComponent } from "../../shared";
import { isMobile } from "../../core";
import { PickingProductivityFilterComponent } from "./picking-productivity-filter/picking-productivity-filter.component";
import { PickingProductivityContentComponent } from "./picking-productivity-content/picking-productivity-content.component";
import { MatDialog } from "@angular/material/dialog";
import moment from "moment";

@Component({
  standalone: false,
  selector: "app-picking-productivity",
  templateUrl: "./picking-productivity.component.html"
})
export class PickingProductivityComponent implements OnInit {
  clearFlag: boolean = false;

  /**
   * Determines whether mobile is
   */
  isMobile = isMobile();
  /**
   * Search filter of picking productivity component
   */
  searchFilter = new BehaviorSubject(undefined);
  /**
   * Change filter of picking productivity component
   */
  changeFilter = new BehaviorSubject(undefined);
  /**
   * View child of picking orders cancel component
   */
  @ViewChild(PickingProductivityFilterComponent)
  filterComponent: PickingProductivityFilterComponent;
  /**
   * View child of picking productivity component
   */
  @ViewChild(PickingProductivityContentComponent)
  contentComponent: PickingProductivityContentComponent;
  /**
   * Creates an instance of picking productivity component.
   * @param dialog MatDialog
   */
  constructor(private dialog: MatDialog) { }
  /**
   * on init
   */
  ngOnInit() {
    //
  }
  /**
   * Determines whether change filter values onbegin
   * @param params any
   */
  onChangeFilterValues(params: any) {
    const obj: any = {};
    obj.entityIds = params.entity.join(":");
    const periodFromTo: string[] = params.period ? params.period.split(":") : null;
    obj.dateInitial = periodFromTo[0];
    obj.dateFinal = periodFromTo[1];
    this.searchFilter.next(obj);
  }

  /**
   * Determines whether change filter on
   * @param value any
   */
  onChangeFilter(value: any) {
    this.changeFilter.next(value);
  }
  /**
   * Determines whether action options on
   */
  onActionOptions() {
    const modalConfirm = this.dialog.open(ModalConfirmComponent, {
      data: "clean",
      disableClose: true,
    });
    modalConfirm.afterClosed().subscribe((response) => {
      if (response) {
        this.contentComponent.accumulated = [];
        this.contentComponent.accumulatedTotal = [];
        this.contentComponent.accumulatedDetail = [];
        this.filterComponent.formResetValues();
        this.clearDateRange();
      }
    });
  }

  clearDateRange() {
    this.clearFlag = !this.clearFlag;
  }
}
